<template>
  <v-card>
    <v-container>
      <v-toolbar elevation="0">
        <v-toolbar-title class="primary--text"><h2>New Area</h2></v-toolbar-title>
      </v-toolbar>
      <v-row class="px-4">
        <v-col cols="12">
          <v-text-field
              v-model="area.name"
              label="Area Name"
          >
          </v-text-field>
        </v-col>
        <v-col cols="6" class="pr-4">
          <v-text-field
              v-model="area.postalCodeStart"
              label="Postal Code Start"
          >
          </v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
              v-model="area.postalCodeEnd"
              label="Postal Code End"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
          v-model="area.postalCodes"
          label="Postal Codes (optional)"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row justify="end" class="px-4">
        <v-col class="text-end">
          <v-btn class="primary" v-on:click="submitNewArea">
          Next
        </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "AddArea",
  props: {
    locationChangeCallback: Function
  },
  data() {
    return {
      area: {
        name: '',
        postalCodeStart: '',
        postalCodeEnd: '',
        postalCodes: []
      }
    }
  },
  methods: {
    submitNewArea() {
      let nums = []
      nums.push(...this.area.postalCodes.split(','));
      const codes = nums.map((value) => Number(value.trim()));
      this.locationChangeCallback({
        ...this.area,
        postalCodeStart: Number.parseInt(this.area.postalCodeStart),
        postalCodeEnd: Number.parseInt(this.area.postalCodeEnd),
        postalCodes: codes
      });
    }
  }
}
</script>

<style scoped>

</style>
